module.exports = __webpack_public_path__ + "img/previewimg.3e22085a.png";